import { Grid, Box, Typography, Button, Card, Stack } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import CurrencyRupeeOutlinedIcon from '@mui/icons-material/CurrencyRupeeOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import WorkOutlineOutlinedIcon from '@mui/icons-material/WorkOutlineOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import StorageOutlinedIcon from '@mui/icons-material/StorageOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';

import { NOT_AVAILABLE } from '../pages/Global/Constants';

const getHeaderIcon = (title) => {
  const t = (title || '').toLowerCase();
  if (t.includes('loan')) return <GridViewOutlinedIcon sx={{ fontSize: 20 }} />;
  if (t.includes('applicant') || t.includes('user') || t.includes('profile'))
    return <PersonOutlineOutlinedIcon sx={{ fontSize: 20 }} />;
  if (t.includes('address')) return <HomeOutlinedIcon sx={{ fontSize: 20 }} />;
  if (t.includes('kyc')) return <VerifiedUserOutlinedIcon sx={{ fontSize: 20 }} />;
  if (t.includes('workflow')) return <AssignmentIndOutlinedIcon sx={{ fontSize: 20 }} />;
  if (t.includes('bank') || t.includes('recommended'))
    return <AccountBalanceOutlinedIcon sx={{ fontSize: 20 }} />;
  if (t.includes('dsa') || t.includes('partner') || t.includes('group'))
    return <GroupsOutlinedIcon sx={{ fontSize: 20 }} />;
  if (t.includes('dataset') || t.includes('data'))
    return <StorageOutlinedIcon sx={{ fontSize: 20 }} />;
  if (t.includes('table') || t.includes('list') || t.includes('record'))
    return <TableChartOutlinedIcon sx={{ fontSize: 20 }} />;
  return <InsertDriveFileOutlinedIcon sx={{ fontSize: 20 }} />;
};

const getIconBoxStyle = (label) => {
  const l = (label || '').toLowerCase();
  if (l.includes('phone') || l.includes('mobile') || l.includes('contact')) {
    return { bgcolor: '#ecfeff', color: '#06b6d4' };
  }
  if (
    l.includes('amount') ||
    l.includes('income') ||
    l.includes('market') ||
    l.includes('payout') ||
    l.includes('verified') ||
    l.includes('score')
  ) {
    return { bgcolor: '#f0fdf4', color: '#10b981' };
  }
  if (l.includes('loan type') || l.includes('type') || l.includes('tenure') || l.includes('foir')) {
    return { bgcolor: '#f5f3ff', color: '#6366f1' };
  }
  if (l.includes('employment') || l.includes('itr') || l.includes('pan') || l.includes('aadhar')) {
    return { bgcolor: '#ecfeff', color: '#0891b2' };
  }
  if (
    l.includes('city') ||
    l.includes('address') ||
    l.includes('district') ||
    l.includes('province') ||
    l.includes('pincode')
  ) {
    return { bgcolor: '#f0f9ff', color: '#0284c7' };
  }
  if (
    l.includes('date') ||
    l.includes('assigned') ||
    l.includes('update') ||
    l.includes('dob') ||
    l.includes('age')
  ) {
    return { bgcolor: '#eff6ff', color: '#3b82f6' };
  }
  return { bgcolor: '#f0f9ff', color: '#0284c7' };
};

export default function ViewCardComponent({
  title = 'Details',
  fields = [],
  handleEdit,
  children
}) {
  return (
    <Grid item xs={12} md={12}>
      <Card
        sx={{
          borderRadius: '16px',
          border: '1px solid #e2e8f0',
          boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
          p: { xs: 2.5, md: 3 },
          bgcolor: '#ffffff',
          position: 'relative',
          mb: 1
        }}
      >
        {/* Card Header */}
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 3, pb: 2, borderBottom: '1px solid #f1f5f9' }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center">
            <Box
              sx={{
                width: 34,
                height: 34,
                borderRadius: '8px',
                bgcolor: '#0284c7',
                color: '#ffffff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              {getHeaderIcon(title)}
            </Box>
            <Typography sx={{ fontSize: '16px', fontWeight: 800, color: '#0f172a' }}>
              {title}
            </Typography>
          </Stack>

          {handleEdit && (
            <Button
              variant="outlined"
              startIcon={<EditOutlinedIcon sx={{ fontSize: 16 }} />}
              onClick={(e) => handleEdit(e, fields)}
              sx={{
                color: '#0284c7',
                borderColor: '#bae6fd',
                bgcolor: '#f0f9ff',
                borderRadius: '8px',
                fontWeight: 600,
                fontSize: '12.5px',
                textTransform: 'none',
                py: 0.6,
                px: 1.75,
                '&:hover': {
                  bgcolor: '#e0f2fe',
                  borderColor: '#0284c7'
                }
              }}
            >
              Edit
            </Button>
          )}
        </Stack>

        {/* Card Fields */}
        {fields && fields.length > 0 && (
          <Grid container spacing={3}>
            {fields.map((field, index) => {
              const iconStyle = getIconBoxStyle(field?.label);
              return (
                <Grid item xs={12} sm={6} md={4} key={index}>
                  <Stack direction="row" spacing={1.75} alignItems="center">
                    <Box
                      sx={{
                        width: 44,
                        height: 44,
                        borderRadius: '12px',
                        bgcolor: iconStyle.bgcolor,
                        color: iconStyle.color,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                        '& svg': { fontSize: 22 }
                      }}
                    >
                      {field?.icon || <InsertDriveFileOutlinedIcon sx={{ fontSize: 22 }} />}
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: '11.5px', color: '#64748b', fontWeight: 500 }}>
                        {field?.label}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '14px',
                          fontWeight: 700,
                          color: '#0f172a',
                          mt: 0.2
                        }}
                      >
                        {field?.value !== undefined && field?.value !== null && field?.value !== ''
                          ? String(field.value)
                          : NOT_AVAILABLE}
                      </Typography>
                    </Box>
                  </Stack>
                </Grid>
              );
            })}
          </Grid>
        )}

        {children}
      </Card>
    </Grid>
  );
}
